/* Concrete — global.js */
(function () {
  'use strict';
  var S = window.CONCRETE || { routes: {}, cartCount: 0 };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  /* Real Shopify money_format parser — uses the shop's format string (window.CONCRETE.money).
     Handles {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}},
     {{amount_no_decimals_with_comma_separator}} and {{amount_with_apostrophe_separator}}. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || S.money || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal = (decimal == null) ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        rem = parts[1] ? (decimal + parts[1]) : '';
      return dollars + rem;
    }
    var match = formatString.match(placeholderRegex), value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  function fmt(cents) { return formatMoney(cents, S.money); }

  /* ---------------- A11y: polite live-region announcements ---------------- */
  var _liveEl = null;
  function liveRegion() {
    if (_liveEl && document.body.contains(_liveEl)) return _liveEl;
    _liveEl = document.createElement('div');
    _liveEl.className = 'visually-hidden';
    _liveEl.setAttribute('role', 'status');
    _liveEl.setAttribute('aria-live', 'polite');
    _liveEl.setAttribute('data-a11y-live', '');
    document.body.appendChild(_liveEl);
    return _liveEl;
  }
  function announce(msg) { if (!msg) return; var el = liveRegion(); el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 30); }
  function cartMsg(n) { return n + (n === 1 ? ' item' : ' items') + ' in your cart'; }

  /* ---------------- Drawers / modals (with focus trap) ---------------- */
  var _opener = null, _trapEl = null;
  function focusable(el) {
    return $$('a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; });
  }
  function onTrapKey(e) {
    if (e.key !== 'Tab' || !_trapEl) return;
    var f = focusable(_trapEl); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openEl(el) {
    if (!el) return;
    _opener = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    if (el.id) $$('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    _trapEl = el.querySelector('.drawer__panel,.fv-search__panel,.fv-cart__panel,.fv-drawer__panel,.search-modal__panel') || el;
    document.removeEventListener('keydown', onTrapKey, true); // guard against duplicate listeners
    document.addEventListener('keydown', onTrapKey, true);
    var f = focusable(_trapEl);
    setTimeout(function () { try { (f[0] || _trapEl).focus(); } catch (e2) { } }, 30);
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    if (el.id) $$('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', onTrapKey, true); _trapEl = null;
    if (_opener && typeof _opener.focus === 'function') { try { _opener.focus(); } catch (e3) { } }
    _opener = null;
  }
  function closeAll() {
    $$('.drawer.is-open,.search-modal.is-open,.fv-drawer.is-open,.fv-search.is-open,.fv-cartd.is-open').forEach(closeEl);
    var any = false; $$('[data-pickup-modal]').forEach(function (m) { if (!m.hidden) { m.hidden = true; any = true; } });
    if (any) document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]'); if (o) { e.preventDefault(); openEl($('#' + o.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); closeAll(); openCart(); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); closeAll(); openEl($('#SearchModal')); var i = $('#SearchModal input[type=search]'); if (i) setTimeout(function(){i.focus();}, 50); return; }
    if (e.target.closest('[data-drawer-close],.drawer__overlay,.search-modal__overlay')) { closeAll(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------------- Cart (AJAX) ---------------- */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function getCart() { return fetch(S.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(S.routes.cart_add + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.data && res.data.description || 'Could not add to cart'); }
        return renderCart().then(function () { if (!opts.silent) openCart(); announce('Added to cart'); return res.data; });
      });
  }
  function changeLine(key, qty) {
    return fetch(S.routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { return renderCart(); }).then(function (cart) { announce(qty === 0 ? 'Removed from cart' : cartMsg(cart.item_count)); return cart; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function lineWasHTML(it) { return (it.original_line_price != it.final_line_price) ? '<s class="cart-line__was">' + fmt(it.original_line_price) + '</s> ' : ''; }
  function lineDiscountsHTML(it) {
    var al = it.line_level_discount_allocations || [];
    if (!al.length) return '';
    return '<ul class="cart-line__discounts">' + al.map(function (d) {
      var t = (d.discount_application && d.discount_application.title) || d.title || '';
      return '<li>' + esc(t) + ' (&minus;' + fmt(d.amount) + ')</li>';
    }).join('') + '</ul>';
  }
  function cartDiscountsHTML(cart) {
    return (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="cart-discounts__row"><span>' + esc(d.title) + '</span><span>&minus;' + fmt(d.total_allocated_amount) + '</span></div>';
    }).join('');
  }
  function renderCart(cartArg) {
    return (cartArg ? Promise.resolve(cartArg) : getCart()).then(function (cart) {
      setCount(cart.item_count);
      var body = $('[data-cart-body]');
      if (body) {
        if (!cart.item_count) {
          body.innerHTML = '<p class="fv-cart__empty">' + esc(window.__t_cart_empty || 'Handlekurven er tom') + '</p>';
        } else {
          body.innerHTML = cart.items.map(function (it) {
            var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
            var props = '';
            var pp = it.properties || {};
            for (var k in pp) { if (pp.hasOwnProperty(k) && pp[k] && k.charAt(0) !== '_') props += '<div class="fv-cartrow__prop">' + esc(k) + ': ' + esc(pp[k]) + '</div>'; }
            return '<div class="fv-cartrow" data-key="' + it.key + '">'
              + '<a class="fv-cartrow__img" href="' + it.url + '"><img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '') + '" alt=""></a>'
              + '<div class="fv-cartrow__info"><a href="' + it.url + '" class="fv-cartrow__title">' + esc(it.product_title) + '</a>'
              + (opts ? '<div class="fv-cartrow__meta">' + esc(opts) + '</div>' : '')
              + props
              + '<div class="fv-cartrow__foot"><div class="fv-cartrow__qty"><button type="button" data-qd aria-label="Færre">&minus;</button><input value="' + it.quantity + '" data-qty-input inputmode="numeric" pattern="[0-9]*" min="0" aria-label="Antall"><button type="button" data-qi aria-label="Flere">+</button></div><div class="fv-cartrow__price">' + fmt(it.final_line_price) + '</div></div>'
              + '<button type="button" class="fv-cartrow__rm" data-rm>Fjern</button></div></div>';
          }).join('');
        }
      }
      var sub = $('[data-cart-subtotal]'); if (sub) sub.innerHTML = fmt(cart.total_price);
      $$('[data-cart-discounts]').forEach(function (el) { el.innerHTML = cartDiscountsHTML(cart); });
      $$('[data-cart-savings]').forEach(function (el) { el.innerHTML = (cart.total_discount > 0) ? ('You save ' + fmt(cart.total_discount)) : ''; });
      $$('[data-checkout]').forEach(function (b) {
        if (cart.item_count < 1) { b.setAttribute('data-disabled', ''); b.setAttribute('aria-disabled', 'true'); }
        else { b.removeAttribute('data-disabled'); b.removeAttribute('aria-disabled'); }
      });
      return cart;
    });
  }
  function openCart() { openEl($('#CartDrawer')); renderCart(); }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line, .fv-cartrow'); if (!line) return;
    if (line.closest('[data-cart-contents]')) return; // cart PAGE is handled by its own controller below
    if (!e.target.closest('[data-qi],[data-qd],[data-rm]')) return;
    var key = line.getAttribute('data-key'); var input = $('input', line); var q = parseInt(input && input.value, 10) || 1;
    if (e.target.closest('[data-qi]')) changeLine(key, q + 1);
    else if (e.target.closest('[data-qd]')) changeLine(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-rm]')) changeLine(key, 0);
  });
  // typed quantity in the drawer
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]'); if (!input) return;
    var line = input.closest('.cart-line, .fv-cartrow'); if (!line || line.closest('[data-cart-contents]')) return;
    var key = line.getAttribute('data-key'); var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 1;
    changeLine(key, q);
  });

  /* ---------------- Cart PAGE (Section Rendering API) ---------------- */
  function cartPageBusy(b) { var c = $('[data-cart-contents]'); if (c) c.setAttribute('aria-busy', b ? 'true' : 'false'); }
  function swapInner(doc, live, sel) { var f = doc.querySelector(sel), c = live.querySelector(sel); if (f && c) c.innerHTML = f.innerHTML; }
  function applyCartSection(htmlStr) {
    var live = $('[data-cart-contents]'); if (!live) return;
    var doc = new DOMParser().parseFromString(htmlStr, 'text/html');
    if (!doc.querySelector('[data-cart-lines]')) { // empty cart → full replace (rebuilds the empty state)
      var all = doc.querySelector('[data-cart-contents]'); if (all) live.innerHTML = all.innerHTML;
      return;
    }
    // targeted swap keeps the accelerated-checkout buttons + note field alive (no re-init needed)
    swapInner(doc, live, '[data-cart-lines]');
    swapInner(doc, live, '[data-cart-totals]');
  }
  function swapCartPage(cart, sid) {
    var html = cart && cart.sections && cart.sections[sid];
    if (html) { applyCartSection(html); return; }
    // fallback: render the section on its own via the Section Rendering API (?sections=)
    fetch(S.routes.cart + '?sections=' + encodeURIComponent(sid), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { var h = data && data[sid]; if (h) applyCartSection(h); else location.reload(); })
      .catch(function () { location.reload(); });
  }
  function cartPageChange(key, qty) {
    var root = $('[data-cart-section]'); if (!root) return;
    var sid = root.getAttribute('data-cart-section');
    cartPageBusy(true);
    fetch(S.routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sid, sections_url: S.routes.cart })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      swapCartPage(cart, sid);
      if (cart && typeof cart.item_count === 'number') { renderCart(cart); announce(qty === 0 ? 'Removed from cart' : cartMsg(cart.item_count)); } else renderCart(); // sync header count + drawer
    }).catch(function () { location.reload(); }).then(function () { cartPageBusy(false); });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-contents]')) return;
    var line = e.target.closest('.cart-line'); if (!line) return;
    var key = line.getAttribute('data-key'); var input = $('input', line); var q = parseInt(input && input.value, 10) || 1;
    if (e.target.closest('[data-qi]')) { e.preventDefault(); cartPageChange(key, q + 1); }
    else if (e.target.closest('[data-qd]')) { e.preventDefault(); cartPageChange(key, Math.max(0, q - 1)); }
    else if (e.target.closest('[data-rm]')) { e.preventDefault(); cartPageChange(key, 0); }
  });
  // typed quantity on the cart page
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]'); if (!input) return;
    var line = input.closest('.cart-line'); if (!line || !line.closest('[data-cart-contents]')) return;
    var key = line.getAttribute('data-key'); var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 1;
    cartPageChange(key, q);
  });
  var _noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]'); if (!note) return;
    clearTimeout(_noteTimer);
    _noteTimer = setTimeout(function () {
      fetch(S.routes.cart + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  // product / card add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]'); if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name=id]'); if (!id || !id.value) { flash(form, 'Select a size'); return; }
    var btn = form.querySelector('[type=submit]'); if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    var item = { id: parseInt(id.value, 10), quantity: parseInt((form.querySelector('[name=quantity]') || {}).value || 1, 10) };
    var plan = form.querySelector('[name=selling_plan]:checked');
    if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);
    // gather line-item properties (personalization: name, coordinates, year, etc.)
    var props = {}, hasProps = false, reqMissing = null;
    $$('[name^="properties["]', form).forEach(function (f) {
      if (f.type === 'checkbox' && !f.checked) return;
      if (f.type === 'radio' && !f.checked) return;
      var m = f.name.match(/^properties\[(.+)\]$/); if (!m) return;
      var val = (f.value || '').trim();
      if (f.hasAttribute('required') && !val && !reqMissing) reqMissing = f;
      if (val) { props[m[1]] = val; hasProps = true; }
    });
    if (reqMissing) { flash(form, reqMissing.getAttribute('data-req-msg') || 'Fyll ut personaliseringen'); reqMissing.focus(); if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to Cart'; } return; }
    if (hasProps) item.properties = props;
    addToCart([item])
      .catch(function (err) { flash(form, err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to Cart'; } });
  });
  function flash(form, msg) { var n = form.querySelector('[data-form-msg]'); if (n) { n.textContent = msg; n.style.opacity = 1; setTimeout(function () { n.style.opacity = 0; }, 2500); } }

  /* ---------------- Quick add (product cards) ----------------
     Capture phase + stopPropagation so the card carousel ([data-carousel][data-href]) never
     treats the tap as a navigate. Single-variant cards add straight to cart and open the drawer;
     multi-variant cards open a small chooser whose chips each add a variant. */
  function qaCloseAll(except) {
    $$('[data-qa].is-open').forEach(function (qa) {
      if (qa === except) return;
      qa.classList.remove('is-open');
      var pop = qa.querySelector('[data-qa-pop]'); if (pop) pop.hidden = true;
      var op = qa.querySelector('[data-qa-open]'); if (op) op.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-qa-open]');
    if (opener) {
      e.preventDefault(); e.stopPropagation();
      var qa = opener.closest('[data-qa]'); var pop = qa && qa.querySelector('[data-qa-pop]');
      var willOpen = !!(pop && pop.hidden);
      qaCloseAll(willOpen ? qa : null);
      if (pop) { pop.hidden = !willOpen; qa.classList.toggle('is-open', willOpen); opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); }
      return;
    }
    var add = e.target.closest('[data-qa-add]');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      if (add.disabled || add.getAttribute('aria-disabled') === 'true' || add.dataset.busy === '1') return;
      var id = parseInt(add.getAttribute('data-id'), 10); if (!id) return;
      add.dataset.busy = '1'; add.classList.add('is-busy');
      addToCart([{ id: id, quantity: 1 }]).catch(function () {}).then(function () {
        add.dataset.busy = ''; add.classList.remove('is-busy'); qaCloseAll(null);
      });
      return;
    }
    if (!e.target.closest('[data-qa-pop]')) qaCloseAll(null);
  }, true);

  /* ---------------- Product quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]'), inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var wrap = (dec || inc).closest('[data-qty]'); if (!wrap) return;
    var input = wrap.querySelector('input[name=quantity]'); if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var val = parseInt(input.value, 10); if (isNaN(val)) val = min;
    val = inc ? val + 1 : Math.max(min, val - 1);
    input.value = val; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Pickup availability modal ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pickup-open]')) { var m = $('[data-pickup-modal]'); if (m) { m.hidden = false; document.body.style.overflow = 'hidden'; } return; }
    if (e.target.closest('[data-pickup-close]')) { $$('[data-pickup-modal]').forEach(function (m) { m.hidden = true; }); document.body.style.overflow = ''; return; }
  });

  /* ---------------- Predictive search ---------------- */
  var stimer;
  function priceStr(p) { if (p == null || p === '') return ''; var n = parseInt(p, 10); if (isNaN(n)) return ''; return fmt(n); }
  function predictGroupHTML(label, list, withImg) {
    if (!list || !list.length) return '';
    var rows = list.map(function (it) {
      var img = (withImg && it.image) ? '<span class="sgroup__img"><img src="' + it.image + '" alt="" loading="lazy"></span>' : '';
      return '<a href="' + it.url + '" class="sgroup__row">' + img + '<span class="sgroup__t">' + esc(it.title) + '</span></a>';
    }).join('');
    return '<div class="sgroup"><div class="sgroup__label">' + label + '</div>' + rows + '</div>';
  }
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive]'); if (!input) return;
    clearTimeout(stimer); var q = input.value.trim();
    var box = (input.closest('.fv-search__panel, .search-modal, .drawer__panel') || document).querySelector('[data-search-results]');
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; box.removeAttribute('data-state'); return; }
    box.setAttribute('data-state', 'loading');
    stimer = setTimeout(function () {
      var prodReq = fetch(S.routes.search + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&view=json', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).catch(function () { return []; });
      var extraReq = S.routes.predict
        ? fetch(S.routes.predict + '.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=article,page&resources%5Blimit%5D=3', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); }).then(function (d) { return (d && d.resources && d.resources.results) || {}; }).catch(function () { return {}; })
        : Promise.resolve({});
      Promise.all([prodReq, extraReq]).then(function (out) {
        var items = out[0] || [], extra = out[1] || {}, articles = extra.articles || [], pages = extra.pages || [];
        var total = items.length + articles.length + pages.length;
        box.setAttribute('data-state', total ? 'results' : 'empty');
        if (!total) { box.innerHTML = '<p class="sresult__none">Ingen treff på &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;</p>'; announce('Ingen treff på ' + q); return; }
        var html = items.map(function (p) {
          return '<a class="sresult" href="' + p.url + '"><span class="sresult__img"><img src="' + (p.image || '') + '" alt="" loading="lazy"></span><span class="sresult__t">' + esc(p.title) + '</span><span class="sresult__p">' + (p.price_varies ? 'Fra ' : '') + priceStr(p.price) + '</span></a>';
        }).join('');
        html += predictGroupHTML('Articles', articles, true) + predictGroupHTML('Pages', pages, false);
        html += '<a class="sresult__all" href="' + S.routes.search + '?q=' + encodeURIComponent(q) + '&type=product,article,page">Se alle treff for &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo; &rsaquo;</a>';
        box.innerHTML = html;
        announce(total + (total === 1 ? ' result' : ' results') + ' for ' + q);
      }).catch(function () { box.removeAttribute('data-state'); });
    }, 200);
  });

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    var els = $$('.reveal'); if (!els.length) return;
    document.documentElement.classList.add('reveal-on'); // arm the hide ONLY when JS runs (content stays visible if JS fails)
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // bulletproof fallback: reveal anything in/near the viewport even if the observer misses
    function sweep() { for (var i = 0; i < els.length; i++) { var e = els[i]; if (!e.classList.contains('in')) { var r = e.getBoundingClientRect(); if (r.top < innerHeight * 0.94 && r.bottom > -40) e.classList.add('in'); } } }
    addEventListener('load', sweep); addEventListener('scroll', sweep, { passive: true }); addEventListener('resize', sweep); setTimeout(sweep, 500); setTimeout(sweep, 1400);
    // final safety net: never leave .reveal content hidden — un-arm after 5s (deco stays armed; it's decorative + the observer/sweep reveal it on scroll)
    setTimeout(function () { document.documentElement.classList.remove('reveal-on'); }, 5000);
  }

  /* ---------------- carousels + lightbox ---------------- */
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }
  var _lb, _lbImg, _lbThumbs, _lbList = [], _lbIdx = 0;
  function lbGo(i) { if (!_lbList.length) return; _lbIdx = (i + _lbList.length) % _lbList.length; _lbImg.src = _lbList[_lbIdx]; each(_lbThumbs.children, function (t, j) { t.classList.toggle('on', j === _lbIdx); }); }
  function lbClose() { if (_lb) { _lb.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function openLightbox(carousel, startIdx) {
    _lb = document.getElementById('Lightbox'); if (!_lb) return;
    if (_lb.parentNode !== document.body) document.body.appendChild(_lb); // escape .page-content stacking context (header was covering it)
    _lbImg = document.getElementById('lbImg'); _lbThumbs = document.getElementById('lbThumbs');
    _lbList = []; each(carousel.querySelectorAll('.pcarousel__slide[data-full]'), function (sl) { var im = sl.querySelector('img'); _lbList.push(sl.getAttribute('data-full') || (im && im.src) || ''); });
    _lbThumbs.innerHTML = _lbList.map(function (s, i) { return '<img src="' + s + '" data-i="' + i + '" alt="">'; }).join('');
    each(_lbThumbs.children, function (b) { b.addEventListener('click', function () { lbGo(+b.getAttribute('data-i')); }); });
    lbGo(startIdx || 0); _lb.classList.add('is-open'); document.body.style.overflow = 'hidden';
  }
  window.CONCRETE.openLightbox = openLightbox;
  function initLightbox() {
    var lb = document.getElementById('Lightbox'); if (!lb || lb._init) return; lb._init = true;
    each(lb.querySelectorAll('[data-lb-close]'), function (b) { b.addEventListener('click', lbClose); });
    var p = lb.querySelector('[data-lb-prev]'), nx = lb.querySelector('[data-lb-next]');
    if (p) p.addEventListener('click', function () { lbGo(_lbIdx - 1); });
    if (nx) nx.addEventListener('click', function () { lbGo(_lbIdx + 1); });
    document.addEventListener('keydown', function (e) { if (_lb && _lb.classList.contains('is-open')) { if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbGo(_lbIdx - 1); else if (e.key === 'ArrowRight') lbGo(_lbIdx + 1); } });
    var stage = lb.querySelector('[data-lb-stage]'), sx = 0, sd = 0, sdrag = false;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { sdrag = true; sx = e.clientX; sd = 0; });
      stage.addEventListener('pointermove', function (e) { if (sdrag) sd = e.clientX - sx; });
      stage.addEventListener('pointerup', function () { if (sdrag) { sdrag = false; if (Math.abs(sd) > 40) lbGo(_lbIdx + (sd < 0 ? 1 : -1)); } });
    }
  }
  function initCarousels() {
    $$('[data-carousel]').forEach(function (c) {
      if (c._car) return; c._car = true;
      var track = c.querySelector('.pcarousel__track'); if (!track) return;
      var n = track.children.length, dots = c.querySelector('.pcarousel__dots');
      var thumbs = c.parentNode ? c.parentNode.querySelector('[data-pcarousel-thumbs]') : null;
      var idx = 0, sx = 0, sy = 0, dx = 0, drag = false, decided = false, horiz = false, moved = false, w = 1;
      function setX(pct, anim) { track.style.transition = anim ? 'transform .35s ease' : 'none'; track.style.transform = 'translateX(' + pct + '%)'; }
      function go(i) { idx = Math.max(0, Math.min(n - 1, i)); setX(-idx * 100, true); if (dots) each(dots.children, function (d, j) { d.classList.toggle('on', j === idx); }); if (thumbs) each(thumbs.children, function (t, j) { t.classList.toggle('is-active', j === idx); }); }
      c._goTo = go; // expose so the variant picker can move the gallery to a variant's featured media
      if (n > 1) {
        c.addEventListener('pointerdown', function (e) { if (e.target.closest('.pmedia-slide')) { drag = false; return; } drag = true; decided = false; horiz = false; moved = false; sx = e.clientX; sy = e.clientY; dx = 0; w = c.offsetWidth || 1; });
        c.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var mx = e.clientX - sx, my = e.clientY - sy;
          if (!decided) {
            if (Math.abs(mx) < 10 && Math.abs(my) < 10) return; // wait for a clear gesture
            decided = true; horiz = Math.abs(mx) > Math.abs(my) + 6; // bias toward vertical SCROLL unless clearly horizontal
            if (horiz) { try { c.setPointerCapture(e.pointerId); } catch (_) { } }
            else { drag = false; return; } // vertical intent: release immediately so the page scrolls normally
          }
          if (horiz) { e.preventDefault(); moved = true; dx = mx; setX(-idx * 100 + dx / w * 100, false); }
        });
        var end = function () { if (!drag) return; drag = false; if (decided && horiz) { if (Math.abs(dx) > w * 0.15) go(idx + (dx < 0 ? 1 : -1)); else go(idx); } };
        c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end);
        if (dots) each(dots.children, function (b, jj) { b.addEventListener('click', function (e) { e.stopPropagation(); go(jj); }); });
        if (thumbs) each(thumbs.children, function (b, jj) { b.addEventListener('click', function (e) { e.stopPropagation(); go(jj); }); });
      }
      c.addEventListener('click', function (e) {
        if (moved) { moved = false; e.preventDefault(); return; }
        if (c.hasAttribute('data-href')) { location.href = c.getAttribute('data-href'); return; }
        if (c.hasAttribute('data-lightbox')) {
          var slide = track.children[idx];
          if (slide && slide.classList.contains('pmedia-slide')) return; // video / 3D: interact in place
          var hasFull = slide && slide.hasAttribute('data-full');
          openLightbox(c, hasFull ? (parseInt(slide.getAttribute('data-img-index'), 10) || 0) : 0);
        }
      });
    });
  }

  /* ---------------- CONCRETE v2: reveal engine (.rv / [data-rv-stagger] / .rv-lines) ---------------- */
  function initRv() {
    var els = $$('.rv,[data-rv-stagger],.rv-lines');
    if (!els.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || document.body.classList.contains('motion-off')) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    document.documentElement.classList.add('rv-armed');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    function sweep() { for (var i = 0; i < els.length; i++) { var e = els[i]; if (!e.classList.contains('in')) { var r = e.getBoundingClientRect(); if (r.top < innerHeight * 0.94 && r.bottom > -40) e.classList.add('in'); } } }
    addEventListener('load', sweep); addEventListener('scroll', sweep, { passive: true }); addEventListener('resize', sweep); setTimeout(sweep, 400); setTimeout(sweep, 1200);
    setTimeout(function () { document.documentElement.classList.remove('rv-armed'); $$('.rv,[data-rv-stagger],.rv-lines').forEach(function (e) { e.classList.add('in'); }); }, 6000);
  }

  /* ---------------- CONCRETE v2: header behaviors (sticky / hide-on-scroll / transparent) ---------------- */
  function initHeader() {
    var hdr = $('[data-header]'); if (!hdr) return;
    var mode = hdr.getAttribute('data-sticky') || 'always';
    var transparent = hdr.hasAttribute('data-transparent');
    var lastY = 0, ticking = false;
    // solidify only after the status bar has scrolled away, so the transparent header
    // never leaves a bare strip above it (--sbar-h defaults to 34px)
    var sbarH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sbar-h')) || 34;
    function onScroll() {
      var y = scrollY || 0;
      if (transparent) hdr.classList.toggle('is-solid', y > sbarH);
      if (mode === 'scroll-up') {
        if (y > lastY && y > 260) hdr.classList.add('is-hidden');
        else hdr.classList.remove('is-hidden');
      }
      lastY = y; ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
    // mega menu: touch/keyboard toggle (hover handled in CSS)
    $$('[data-mega-toggle]', hdr).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var item = btn.closest('[data-mega-item]'); if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { e.preventDefault(); }
        $$('[data-mega-item].is-open', hdr).forEach(function (it) { if (it !== item) { it.classList.remove('is-open'); var b = it.querySelector('[data-mega-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
      });
    });
    // keep aria-expanded in sync with the CSS hover/focus-open state
    $$('[data-mega-item]', hdr).forEach(function (item) {
      var btn = item.querySelector('[data-mega-toggle]'); if (!btn) return;
      function sync(open) { if (!item.classList.contains('is-open')) btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { sync(true); });
      item.addEventListener('mouseleave', function () { sync(false); });
      item.addEventListener('focusin', function () { sync(true); });
      item.addEventListener('focusout', function () { if (!item.contains(document.activeElement)) sync(false); });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega-item]')) $$('[data-mega-item].is-open', hdr).forEach(function (it) { it.classList.remove('is-open'); var b = it.querySelector('[data-mega-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('[data-mega-item].is-open', hdr).forEach(function (it) { it.classList.remove('is-open'); var b = it.querySelector('[data-mega-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }); });
  }

  /* ---------------- product-card image carousel (drag/swipe to switch, dots sync) ---------------- */
  function initCardCarousels(root) {
    (root || document).querySelectorAll('[data-card-track]').forEach(function (track) {
      if (track._cardInit) return; track._cardInit = 1;
      var card = track.closest('.fv-card');
      var dotsWrap = track.parentElement.querySelector('[data-card-dots]');
      var dots = dotsWrap ? dotsWrap.children : [];
      var ticking = false;
      function sync() {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === i);
      }
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });
      // dots jump to a slide without triggering the card link
      for (var k = 0; k < dots.length; k++) {
        (function (idx) {
          dots[idx].addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          });
        })(k);
      }
      // mouse drag-to-scroll (touch scrolls natively). suppress the card link click after a drag.
      var down = false, moved = false, sx = 0, sl = 0, pid = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; pid = e.pointerId;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = sl - dx;
        e.preventDefault();
      });
      function endDrag(e) {
        if (!down) return; down = false;
        track.classList.remove('is-dragging');
        try { if (pid != null) track.releasePointerCapture(pid); } catch (_) {}
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        if (moved && card) {
          card._suppressClick = true;
          setTimeout(function () { card._suppressClick = false; }, 80);
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      if (card && !card._clickGuard) {
        card._clickGuard = 1;
        card.addEventListener('click', function (e) {
          if (card._suppressClick) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }
    });
  }

  /* ---------------- init ---------------- */
  function init() { setCount(S.cartCount || 0); initReveal(); initRv(); initHeader(); initCarousels(); initCardCarousels(); initLightbox(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  // expose for sections
  window.CONCRETE.addToCart = addToCart; window.CONCRETE.openCart = openCart; window.CONCRETE.renderCart = renderCart; window.CONCRETE.formatMoney = formatMoney; window.CONCRETE.initCarousels = initCarousels; window.CONCRETE.initCardCarousels = initCardCarousels;
})();
